import React from "react";

const OrderCard = ({ order, onComplete }) => {
  
  return (
    <div className="mb-4 shadow-sm border-0 rounded-4">
      {/* En-tête de la commande */}
      <div className="card-header bg-dark text-white rounded-top">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <i className="bi bi-receipt-cutoff me-2"></i>Commande #{order._id}
          </h5>
          <span
            className={`badge ${
              order.status === "Pending" ? "bg-warning" : "bg-success"
            }`}
          >
            {order.status}
          </span>
        </div>
        <p className="mb-0"><strong>Date :</strong> {new Date(order.dateOrdered).toLocaleDateString()}</p>
      </div>

      {/* Informations client */}
      <div className="card-body">
        <h6 className="text-muted mb-3"><i className="bi bi-person-fill me-2"></i>Informations client</h6>
        <div className="row">
          <div className="col-md-6 mb-2">
            <p className="mb-1"><strong>Nom :</strong> {order?.user?.firstName} {order?.user?.lastName}</p>
            <p className="mb-1"><strong>Email :</strong> {order?.user?.email || order?.email }</p>
            <p className="mb-1"><strong>Phone :</strong> {order?.user?.phone || "Non fourni"}</p>
          </div>
          <div className="col-md-6 mb-2">
            <p className="mb-1"><strong>Adresse :</strong> {order?.shippingAddress1 || "Anonyme"}</p>
            <p className="mb-1"><strong>Ville :</strong> {order?.city || "Non spécifiée"}</p>
            <p className="mb-1"><strong>Pays :</strong> {order?.country || "Non spécifié"}</p>
            <p className="mb-1"><strong>Code postal :</strong> {order?.zip}</p>
            <p className="mb-1"><strong>Entreprise :</strong> {order?.companyName || "Non spécifiée"}</p>
          </div>
        </div>
      </div>

      {/* Liste des articles commandés */}
      <div className="card-body">
        <h6 className="text-muted mb-3"><i className="bi bi-box-seam me-2"></i>Articles commandés</h6>
        <ul className="list-group list-group-flush">
          {order?.orderItems?.map((item) => (
            <li
              key={item._id}
              className="list-group-item d-flex align-items-center"
            >
              <img
                src={item.product.images[0]}
                alt={item.product.name}
                className="rounded me-3"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />
              <div>
                <p className="mb-1"><strong>Produit :</strong> {item.product.name}</p>

                <p className="mb-1"><strong>Quantité :</strong> {item.quantity}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Bouton de complétion */}
      {order?.status === "Pending" && (
        <div className="card-footer bg-light text-end rounded-bottom">
          <button
            className="btn btn-success btn-sm"
            onClick={() => onComplete(order._id)}
          >
            <i className="bi bi-check-circle me-1"></i> Marquer comme terminée
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderCard;
